import type { CarouselTemplate } from "../types";
import { fieldDiary } from "./field-diary";
import { minimalLight } from "./minimal-light";
import { boldModern } from "./bold-modern";
import { elegant } from "./elegant";
import { glassBar } from "./glass-bar";
import { magazine } from "./magazine";
import { handwritten } from "./handwritten";
import { gallery } from "./gallery";

export const TEMPLATES: Record<string, CarouselTemplate> = {
  [fieldDiary.id]: fieldDiary,
  [elegant.id]: elegant,
  [glassBar.id]: glassBar,
  [magazine.id]: magazine,
  [handwritten.id]: handwritten,
  [gallery.id]: gallery,
  [minimalLight.id]: minimalLight,
  [boldModern.id]: boldModern,
};

export const TEMPLATE_LIST: CarouselTemplate[] = Object.values(TEMPLATES);
export const DEFAULT_TEMPLATE = fieldDiary;
